export default __webpack_public_path__ + "static/media/carrot.dc87523c.png";